/// <amd-module name="Pipeline/Analytics/PipelineDurationCommon/Types" />
export interface Point {
    x: number;
    y: number;
}

export interface IPipelineDurationData {
    pipelineCount: number;
    totalDuration?: number;
    percentileDuration?: number;
}

export interface IMaxDurationTaskData {
    taskName: string;
    taskDuration: number;
    allTasksDuration: number;
}
